import { ZEB_IMPRINT_URL, ZEB_PRIVACY_URL } from 'src/lib/constants.ts';

const FOOTER_LINK =
  'relative inline-flex transition-colors hover:text-zeb-primary after:absolute after:inset-x-0 after:-bottom-1 after:h-px after:origin-left after:scale-x-0 after:bg-zeb-primary after:transition-transform hover:after:scale-x-100 motion-reduce:after:transition-none';

export function Footer() {
  return (
    <footer className="border-t border-zeb-muted mt-20">
      <div className="mx-auto max-w-6xl px-5 lg:px-10 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-sm text-zeb-gray-500">
        <div>© {new Date().getFullYear()} zeb consulting</div>
        <div className="flex gap-6">
          <a
            href={ZEB_PRIVACY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={FOOTER_LINK}>
            Datenschutz
          </a>
          <a
            href={ZEB_IMPRINT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={FOOTER_LINK}>
            Impressum
          </a>
        </div>
      </div>
    </footer>
  );
}
